import React from 'react';
import './WebSearchResults.css';

/**
 * WebSearchResults - Component for displaying web search results in the sliding panel
 * Inspired by llamatutor's Sources.tsx but adapted for morpheus-rl's sliding panel
 */
const WebSearchResults = ({ searchData }) => {
  if (!searchData || !searchData.results || searchData.results.length === 0) {
    return (
      <div className="web-search-results">
        <div className="search-header">
          <h3>No Search Results</h3>
          <p>No results found for this search.</p>
        </div>
      </div>
    );
  }

  const { query, results, total_results, provider } = searchData;

  // Separate web and video results
  const webResults = results.filter(result => result.type === 'web' || !result.type);
  const videoResults = results.filter(result => result.type === 'video');

  return (
    <div className="web-search-results">
      <div className="search-header">
        <h3>Search Results</h3>
        <p className="search-query">"{query}"</p>
        <p className="search-meta">
          {total_results} result{total_results !== 1 ? 's' : ''} • Powered by {provider}
        </p>
      </div>
      
      <div className="search-results-container">
        {/* Web Results */}
        {webResults.map((result, index) => (
          <div key={index} className="search-result-card">
            <div className="result-header">
              <div className="result-favicon">
                {/* Use Google's favicon service for website icons */}
                <img 
                  src={`https://www.google.com/s2/favicons?domain=${new URL(result.url).hostname}&sz=16`}
                  alt=""
                  className="favicon"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div className="result-content">
                <h4 className="result-title">
                  <a 
                    href={result.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="result-link"
                  >
                    {result.title}
                  </a>
                </h4>
                <p className="result-url">
                  {new URL(result.url).hostname}
                </p>
              </div>
            </div>
            
            {result.description && (
              <p className="result-description">
                {result.description}
              </p>
            )}
            
            {result.published && (
              <p className="result-meta">
                Published: {result.published}
              </p>
            )}
          </div>
        ))}

        {/* Video Results Section */}
        {videoResults.length > 0 && (
          <div className="video-results-section">
            <h4 className="video-section-title">📹 Related Videos</h4>
            {videoResults.map((result, index) => (
              <div key={`video-${index}`} className="video-result-card">
                <a 
                  href={result.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="video-link"
                >
                  {result.thumbnail ? (
                    <div className="video-thumbnail">
                      <img 
                        src={result.thumbnail} 
                        alt={result.title}
                        className="thumbnail-image"
                        onError={(e) => {
                          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjkwIiB2aWV3Qm94PSIwIDAgMTIwIDkwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTIwIiBoZWlnaHQ9IjkwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik00OCA0MEw3MiA1MEw0OCA2MFY0MFoiIGZpbGw9IiM5OTk5OTkiLz4KPC9zdmc+';
                        }}
                      />
                      <div className="play-overlay">▶️</div>
                    </div>
                  ) : (
                    <div className="video-placeholder">
                      <span className="video-icon">📹</span>
                    </div>
                  )}
                  <div className="video-content">
                    <h5 className="video-title">{result.title}</h5>
                    {result.description && (
                      <p className="video-description">{result.description}</p>
                    )}
                  </div>
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="search-footer">
        <p className="search-note">
          💡 All links open in a new tab for easy reference while you continue your conversation.
        </p>
      </div>
    </div>
  );
};

export default WebSearchResults;